// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2JSxp","topBottomGutter":"Layout_topBottomGutter__ZOXpp"};